import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL } from '../../data/dgpt';
import { McpWaitlistButton } from '../mcp/McpWaitlistButton';
import { CtaButton } from '../ui/CtaButton';
import { HeroReview } from '../examples/HeroReview';
export function HomeHero() {
  const reduceMotion = useReducedMotion();
  const fadeUp = (delay = 0) => reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.55,
      delay,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  };
  return <section aria-labelledby="hero-heading" className="dgpt-dark relative overflow-hidden bg-night" data-id="element-629" data-mp="2n2hc71b7uuz9">
      <div className="dgpt-night-grid sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-630" data-mp="3fszgg5nof2e9" />
      <div className="relative mx-auto grid w-full max-w-[1320px] gap-12 px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-14 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-631" data-mp="3kjftvprhyo0m">
        <div className="flex flex-col items-start" data-id="element-632" data-mp="jwnz3se6iqdg">
          <motion.p {...fadeUp(0)} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-night-muted" data-id="element-633" data-mp="jxz2hr3ppw41">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-violet" data-id="element-634" data-mp="swaotgxjq7qo" />
            DiligenceGPT™
          </motion.p>
          <motion.h1 {...fadeUp(0.05)} id="hero-heading" className="mt-6 text-[40px] font-semibold leading-[1.02] tracking-[-0.035em] text-night-text sm:text-[60px] lg:text-[68px] xl:text-[76px]" data-id="element-635" data-mp="17kf9gqg5stc3">
            AI that Masters Due Diligence:
            <br data-id="element-636" data-mp="1cluy0shjphz8" />
            <span className="text-[#A995FF]" data-id="element-637" data-mp="1clbcz2wlmdgz">Leave no stone unturned.</span>
          </motion.h1>
          <motion.p {...fadeUp(0.1)} className="mt-7 max-w-xl text-base leading-relaxed text-night-muted sm:text-lg" data-id="element-638" data-mp="3iea0zv1p1vvo">
            Improve decision-making, shorten the time to a decision, and reduce due diligence costs.
          </motion.p>

          <motion.div {...fadeUp(0.15)} className="mt-9 flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-639" data-mp="1man7v395k96c">
            <CtaButton href={GET_STARTED_URL} variant="violet" size="xl" event="primary_cta_click" eventParams={{
            placement: 'hero',
            cta: 'build_first_process'
          }} className="w-full sm:w-auto" data-id="element-640" data-mp="1r9zqtcwwkw3n">
              Build Your First Process
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-641" data-mp="258fz38aeyunw" />
            </CtaButton>
            <McpWaitlistButton placement="hero" variant="outlineDark" size="xl" className="w-full sm:w-auto" data-id="element-642" data-mp="2a192nsu5bwye" />
          </motion.div>
        </div>

        <motion.div {...reduceMotion ? {} : {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          duration: 0.7,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
        }
      }} className="min-w-0" data-id="element-643" data-mp="2f1do7x9wvhvh">
          <HeroReview data-id="element-644" data-mp="89z4cmln9zyx" />
        </motion.div>
      </div>
    </section>;
}